import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import Header from './Header';

class Submitted extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Submitted message area start */}
                <div className="container margin-70 mb-5">
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-9 submitted">
                            <i className="fa fa-cloud-upload fa-5x upload-icon"></i>
                            <h1>Your collection has been submitted for approval.</h1>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                                euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
                                minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex</p>
                        </div>
                    </div>
                </div>
                {/* Submitted message area end */}
            </div>
        )
    }
};

export default Submitted;